import RedeemForm from './RedeemForm.view';

export default RedeemForm;
